module.exports = "pegasus/assets/themelp1/small/2.png";